(function() {
	// module
	var Modeller = (function() {
		var __private = {
			input: null,
			select: null,

			method: "GET",
			url: false,

			set(elem, options) {
				if(elem instanceof HTMLInputElement) this.input = elem;

				if(options instanceof Object) {
					if(options.hasOwnProperty("select") && options.select instanceof HTMLSelectElement) this.select = options.select;
					else { /* TODO: create select */ } 

					if(options.hasOwnProperty("method")) this.method = options.method;
					if(options.hasOwnProperty("url"))    this.url    = options.url;
				}
			},

			run() {
				if(this.input !== null) this.ajax();
			},

			ajax() {
				var ajax = new XMLHttpRequest();

				if(!this.url) throw new Error("Please, set URL for ajax");

				ajax.open(this.method, this.url, true);
				ajax.onload = function() {
					var list = JSON.parse(ajax.responseText).map(function(i) { return i.name; });
					new Awesomplete(__private.input, { list: list });
				};
				ajax.send();
			}
		};

		return {
			init(elem, options) {
				__private.set(elem, options);
				__private.run();
			}
		};
	})();


	// run script
	// WARN!!! Need add libraries
	document.addEventListener("DOMContentLoaded", function() {

		var input = document.getElementById("ajaxMake");
		var select= document.getElementById("ajaxModel");

		if(input instanceof HTMLInputElement) {
			Modeller.init(input, {
				select: select,
				method: "GET",
				url   : "https://restcountries.eu/rest/v1/lang/fr" // for exemple
			});
		}
	});
})();